import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateEcheanceStatut',
  standalone: true
})
export class DateEcheanceStatutPipe implements PipeTransform {

  transform(dateEcheance?: Date, ...args: unknown[]): 'success' | 'warning' | 'error' | 'info' {
    return dateEcheance
      ? dateEcheance.getTime() > new Date().getTime()
        ? 'info'
        : 'error'
      : 'error';
  }
}
